export default "__VITE_ASSET__BTkPFFJ$__"